import React from "react";

import AddressModel from "./addressModel";
import DateModel from "./dateModel";
import { Button, Form } from "antd";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

import Caricon from "../../../assets/images/cars-icon.png";

import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const HomeSearchBox = () => {
  return (
    <section className="homesearchbox-wrap">
      <Container>
        <Row>
          <Col md={12}>
            <div className="homesearchbox">
              <div className="homesearchbox-top">
                <Row>
                  <Col lg={12} className="homesearchbox-top-left">
                    <div className="se-left-inner">
                      <img src={Caricon} alt="Car Icon" />
                      <h2>Car Rental</h2>
                      <span>For hours & days</span>
                    </div>
                  </Col>
                  <Col lg={12} className="text-end homesearchbox-top-right">
                    <h3>Car Rental in <span> Mumbai</span></h3>
                  </Col>
                </Row>
              </div>
              <div className="homesearchbox-bottom">
                <Form>
                  <Row>
                    <Col lg={10}>
                      <Row>
                        <Col md={12} lg={6}>
                          <AddressModel icon= {<LocationOnOutlinedIcon className='location-input-icon'/>}/>

                          {/* <div className="pickup-address">
                            <Input placeholder="Pick up address" />
                            <span className="locationicon">
                              <LocationOnOutlinedIcon />
                            </span>
                          </div> */}
                        </Col>

                        <Col md={12} lg={6} className="main-datepicker-wrap">
                          <Row>
                            <Col md={12}>

                              <DateModel
                                title="Choose Trip Date"
                                mainHeading="Start time & Date "
                              />

                              {/* <Input placeholder="Start time & date" /> */}
                            </Col>
                           
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={2} md={12}>
                    <Link to="carbookinglist"> 
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="search-submit-btn"
                      > 
                      
                        Find Cars
                        <SearchOutlinedIcon />
                      </Button>
                      </Link>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeSearchBox;
